<template>
  <div class="liu pos-manage">
    <mt-header fixed title="商户信息" class="title2">
      <mt-button slot="left" icon="back" @click="onTopBackClick">返回</mt-button>
      <mt-button slot="right" v-if="detailData.status.value===7 && detailData.addPayStatus===1" @click="onTopAddPosClick">加机</mt-button>
      <mt-button slot="right" v-if="detailData.status.value===6" @click="onTopToEditClick">重新编辑</mt-button>
      <mt-button slot="right" v-if="detailData.status.value===1 && queryEaStatus!=='99' && queryEaStatus!=='4' && queryEaStatus!=='5'" @click="onFlowStartClick">发起协议</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight">
      <div class="form mt-15">
        <!-- 标题 -->
        <div class="title">
          <span>进件详情</span>
        </div>
        <!-- 商户名 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ detailData.companyName.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ detailData.companyName.value }}</span>
            </div>
          </div>
        </div>
        <!-- 商户详细地址 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ detailData.companyAddress.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ detailData.companyAddress.value }}</span>
            </div>
          </div>
        </div>
        <!-- 手机号 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ detailData.corporationMobile.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ detailData.corporationMobile.value }}</span>
            </div>
          </div>
        </div>
        <!-- 进件时间-->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ detailData.addDate.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ detailData.addDate.value }}</span>
            </div>
          </div>
        </div>
        <!-- 商户类型-->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ detailData.typeChs.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ detailData.typeChs.value }}</span>
            </div>
          </div>
        </div>
        <!-- 认证状态 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ detailData.statusChs.label }}</span>
            </div>
            <div class="content tar">
              <span>{{ detailData.statusChs.value }}</span>
            </div>
          </div>
        </div>
        <!-- 开通微信支付 -->
        <div class="row" v-if="detailData.status.value===7">
          <div class="item">
            <div class="label">
              <span>微信支付</span>
            </div>
            <div class="content tar" v-if="detailData.wxStatus===1">
              <span>已开通</span>
            </div>
            <div class="content tar link" v-if="detailData.wxStatus===0" @click="onOpenPayPageClick('wx')">
              <span>开通微信支付</span>
            </div>
          </div>
        </div>
        <!-- 开通支付宝支付，2022.8.12 -->
        <div class="row" v-if="detailData.status.value===7">
          <div class="item">
            <div class="label">
              <span>支付宝支付</span>
            </div>
            <div class="content tar" v-if="detailData.aliStatus===1">
              <span>已开通</span>
            </div>
            <div class="content tar link" v-if="detailData.aliStatus===0" @click="onOpenPayPageClick('ali')">
              <span>开通支付宝支付</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 拒绝理由 -->
      <div class="form mt-15" v-if="detailData.status.value===6">
        <!-- 标题 -->
        <div class="title">
          <span>{{ detailData.auditRefuseMsg.label }}</span>
        </div>
        <!-- 当前进度 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <div class="word">
                <div class="word-content">
                  <span>{{ detailData.auditRefuseMsg.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 活体检测网址-->
      <div class="form mt-15" v-if="detailData.status.value===1 && detailData.type.value==1">
        <!-- 标题 -->
        <div class="title">
          <span>{{ detailData.bodyUrl.label }}</span>
        </div>
        <!-- 网址 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <div class="word">
                <div class="word-content">
                  <span>请复制<span class="tip">{{ detailData.bodyUrl.value }}</span>此URL并发送给商户进行商户认证</span>
                </div>
              </div>
              <div class="copy">
                <span v-clipboard:copy="detailData.bodyUrl.value" v-clipboard:success="onWordCopySuccess" v-clipboard:error="onWordCopyError">点击这里复制URL</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 当前进度 -->
      <div class="form mt-15" v-if="content.show">
        <!-- 标题 -->
        <div class="title">
          <span>{{ content.title }}</span>
        </div>
        <!-- 当前进度 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <div class="word">
                <div class="word-content">
                  <span>{{ content.text }}</span>
                </div>
              </div>
              <div class="copy">
                <span v-clipboard:copy="content.copy" v-clipboard:success="onWordCopySuccess" v-clipboard:error="onWordCopyError">{{ content.link }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn" v-if="detailData.status.value===7">
        <mt-button type="primary" size="large" :disabled="sendBtn.disabled" @click="onSendNotificationClick">
          {{ sendBtn.label }}
        </mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { QueryCustomerDetails, SendCustomerNotification, ResendEAgreement, QueryCustomerBlacklist } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'PosManageDetail',
  data() {
    return {
      detailData: {
        companyName: { label: '商户名', value: '' },
        companyAddress: { label: '详细地址', value: '' },
        corporationMobile: { label: '手机号', value: '' },
        addDate: { label: '进件时间', value: '' },
        type: { label: '商户类型', value: '' },
        typeChs: { label: '商户类型', value: '' },
        status: { label: '认证状态', value: '' },
        statusChs: { label: '认证状态', value: '' },
        bodyUrl: { label: '提示信息', value: '' },
        auditRefuseMsg: { label: '拒绝原因', value: '' },
        smsStatus: 0,
        wxStatus: 0,
        aliStatus: 0,
        addPayStatus: 1,
      },
      content: {
        title: '',
        text: '',
        copy: '',
        link: '',
        show: false,
      },
      sms: { status: '', content: '' },
      btns: [
        {
          type: 'send',
          label: '短信通知',
          disabled: false,
          timing: null,
        },
      ],
      smsSuccess: false,
      shortUrl: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.queryCustomerDetails();
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    queryEaStatus() {
      return this.$route.query.eaStatus || '99';
    },
    sendBtn() {
      return this.btns.filter(item => item.type === 'send')[0];
    },
  },
  methods: {
    // 通过接口获取数据
    queryCustomerDetails(isLoading = true) {
      if (isLoading) CusLoadingOpen();
      QueryCustomerDetails({ id: this.$route.query.id })
        .then(res => {
          if (isLoading) CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.POS_MANAGE_MODULE.globalData = res.data;
              this.detailData.companyName.value = res.data.company.companyName;
              this.detailData.companyAddress.value = res.data.company.companyAddress;
              this.detailData.corporationMobile.value = res.data.idCardInfo.mobile;
              this.detailData.addDate.value = res.data.insertDate;
              this.detailData.type.value = res.data.subjectType;
              this.detailData.typeChs.value = this.subjectTypeChs(res.data.subjectType);
              this.detailData.status.value = res.data.status;
              this.detailData.statusChs.value = this.statusChs(res.data.status);
              this.detailData.auditRefuseMsg.value = res.data.auditRefuseMsg;
              this.detailData.smsStatus = res.data.smsNotificationStatus;
              this.detailData.wxStatus = this.isNull(res.data.weChatPayStatus) ? 0 : res.data.weChatPayStatus;
              this.detailData.aliStatus = this.isNull(res.data.aliPayStatus) ? 0 : res.data.aliPayStatus;
              this.detailData.addPayStatus = this.isNull(res.data.showAddPayTag) ? 1 : res.data.showAddPayTag;
              if (res.data.smsText) {
                this.content.show = true;
                this.content.title = '短信内容';
                this.content.link = '点击这里复制短信内容';
                this.content.text = res.data.smsText;
                this.content.copy = res.data.smsText;
              }
              this.detailData.bodyUrl.value = `${location.href.split('?')[0]}?product=cxzfzs#/posmanagemodule/livingbody?id=${res.data.id}`;
            },
            (code, msg) => {
              if (isLoading) CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          if (isLoading) CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取数据
    sendCustomerNotification() {
      SendCustomerNotification({ _id: this.$route.query.id })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusToast(res.msg);
              this.queryCustomerDetails(false);
            },
            (code, msg) => {
              msg && CusToast(msg);
              if (this.detailData.smsStatus === 1) {
                if (code === 1) {
                  this.content.show = true;
                  this.content.title = '短信内容';
                  this.content.link = '点击这里复制短信内容';
                  this.content.text = res.data;
                  this.content.copy = res.data;
                }
              }
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取当前代理商是否在黑名单中
    queryCustomerBlacklist(callback = null) {
      CusLoadingOpen();
      QueryCustomerBlacklist({ _id: this.$route.query.id })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              const data = res.data;
              if (data.agentStatus === 0 && data.idCardStatus === 0 && data.businessLicenseStatus === 0) {
                callback && callback();
              }
              if (data.agentStatus === 1) {
                CusToast('您的账号暂时无法使用该功能');
              } else {
                if (data.businessLicenseStatus === 1) {
                  CusToast('该营业执照暂时无法进件，请更换后重试');
                } else {
                  if (data.idCardStatus === 1) {
                    CusToast('该身份证暂时无法进件，请更换后重试');
                  }
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回开通类型的中文
    subjectTypeChs(val) {
      if (val === 0) return '营业执照';
      if (val === 1) return '小微商户';
      if (val === 2) return '商户自助注册邀请码';
    },
    // 返回状态的中文
    statusChs(val) {
      if (val === 1) return '审核中';
      if (val === 5) return '审核通过';
      if (val === 6) return '审核不通过';
      if (val === 7) return '商户已建';
    },
    // 判断是否是null
    isNull(val) {
      return !val && val !== 0 && typeof val !== 'boolean';
    },
    // 返回事件
    onTopBackClick() {
      this.$router.go(-1);
    },
    // 加机功能按钮单击事件
    onTopAddPosClick() {
      this.$router.push({ path: '/posmanagemodule/posbind', query: { id: this.$route.query.id, companyName: this.detailData.companyName.value } });
    },
    // 顶部重新编辑按钮单击事件
    onTopToEditClick() {
      this.queryCustomerBlacklist(() => {
        this.$router.push({ path: '/posmanagemodule/posedit', query: { id: this.$route.query.id, producttype: this.detailData.type.value } });
      });
    },
    // 顶部发起审核流程按钮单击事件
    onFlowStartClick() {
      ResendEAgreement({ _id: this.$route.query.id })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data === 4) {
                CusAlert('协议发起成功，请及时查阅并签署协议', () => {
                  this.$router.go(-1);
                });
              } else {
                CusAlert('发起失败，请再次点击按钮，重新发起协议流程');
              }
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.tmp.getRateCodeErrMsg = msg;
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 开通微信支付单击事件
    onOpenPayPageClick(type) {
      this.$router.push({ path: '/posmanagemodule/openpaypage', query: { id: this.$route.query.id, payType: type } });
    },
    // 发送短信按钮单击事件
    onSendNotificationClick() {
      this.$nextTick(() => {
        this.sendCustomerNotification();
      });
    },
    // 文字拷贝成功事件
    onWordCopySuccess() {
      CusToast('复制成功');
    },
    // 文字拷贝失败事件
    onWordCopyError() {
      CusToast('复制失败');
    },
  },
};
</script>
